import { IconButton, Icon, Button, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Pressable, Text } from 'native-base';
import React from 'react';

interface HeaderProps {
  goBack: () => void;
  isLoading?: boolean;
  canUpdate?: boolean;
  onRefresh?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ goBack, isLoading, onRefresh, canUpdate }) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const goBackButton = useBreakpointValue({
    base: (
      <IconButton
        icon="Close"
        testId={'button-close'}
        iconColor={Color['neutral.dark']}
        iconSize="xxs"
        onPress={goBack}
      />
    ),
    lg: (
      <Pressable testID={'button-close-filter-screen'} onPress={goBack}>
        <Icon
          testID={'icon-close-filter-screen'}
          name="Close"
          size="xs"
          variant="rounded"
          borderWidth={0.05}
          backgroundColor="transparent"
          color={Color['brand.primary.principal']}
          borderColor={Color['brand.primary.principal']}
        />
      </Pressable>
    ),
  });

  return (
    <VStack
      alignItems={'center'}
      w={'full'}
      p={Spacing['inline.xxs']}
      borderTopRadius={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxxs'], lg: 0 }}
      backgroundColor={Color['neutral.white']}
      space={Spacing['inline.xxxs']}>
      {!isDesktop && (
        <Box w="55px" background={'neutral.lightest'} borderRadius={BoxRadius.sm} h={1} />
      )}
      <HStack
        w={'full'}
        space={Spacing['stack.quarck']}
        alignItems="center"
        justifyContent={'space-between'}>
        <Text variant="semibold" fontSize={Typography['fontsize.lg']}>
          Livro de ofertas
        </Text>
        <HStack alignItems="center">
          {canUpdate && (
            <Button
              isDisabled={isLoading}
              onPress={onRefresh}
              variant="textLink"
              rightIcon={
                <Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />
              }
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
              Atualizar
            </Button>
          )}
          {goBackButton}
        </HStack>
      </HStack>
    </VStack>
  );
};
